export default "__VITE_ASSET__NpChkWj$__"